import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { ProgressSpinner } from 'primereact/progressspinner';

import { setLPDetails } from '../../slices/createLPSlice';
import IdTemplate from '../../components/predefinedtemplates/lps/IdTemplate';
import NetLinePOC from '../../components/predefinedtemplates/lps/netLineTemplate';
import { hide } from "../../slices/topMenuSlice";
import { LandingPageServe } from '../../services/api/LandingPageServ';
import { setEdit } from "../../slices/authSlice";

import TrendLineTemplate from '../../components/predefinedtemplates/lps/trendLineTemplate.js';

import BeckersTemplate from '../../components/predefinedtemplates/lps/beckersDemad7.js';
const PreviewLp = () => {
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);

    dispatch(hide())
    const { id } = useParams();
    const lpDetails = useSelector((state) => state.createLp.data)


    const getLP = async () => {
        try {
            setLoader(true)
            let data = await LandingPageServe.single(id);
            localStorage.setItem('template_name' , data.templateName)
            dispatch(setLPDetails(data));
        } catch (error) {
            console.log(error)
        } finally {
            setLoader(false)
        }
    }

    useEffect(() => {
        if (!lpDetails._id) {
            getLP()
        }
        dispatch(setEdit(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lpDetails]);


    return (
        <>
            {loader && <ProgressSpinner aria-label="Loading"  style={{margin : "20% 46%"}}/>}
       
        
        { localStorage.getItem('template_name') === 'ID Template' ? (
          <IdTemplate></IdTemplate>
      ) :  (localStorage.getItem('template_name') === 'NetLine Template' || localStorage.getItem('template_name') === 'NL Template') ? (
        <NetLinePOC></NetLinePOC>
      ) : (localStorage.getItem('template_name') === 'Trendline ID Template' || localStorage.getItem('template_name') === 'Trendline Template') ? (
        <TrendLineTemplate></TrendLineTemplate>
      ) :(localStorage.getItem('template_name') === "Demand7-Becker's Campaign" || localStorage.getItem('template_name') === "Demand7-Becker's Campaign") ? (
        <BeckersTemplate></BeckersTemplate>
      ) : (
        <p>Template Not found</p>
      )}
        
        </>
      )
    }

export default PreviewLp